import AV from "leancloud-storage"; 
class Grade extends AV.Object {
  get grade() {
    return this.get('grade');
  }
  set grade(value) {
    this.set('grade', value);
  }	 

  get id() {
    return this.get('id');
  }
  set id(value) {
    this.set('id', value);
  }

}
AV.Object.register(Grade, 'NJGrade');
export default Grade